import { FormattedMessage } from 'react-intl';

export enum NotificationType {
    Error = 'Error',
    Info = 'Info',
}

export enum NotificationDuration {
    Short,
    Long
}

export class Notification {
    cause: string;
    message: string | FormattedMessage.MessageDescriptor;
    messageValues?: {[key: string]: string | number | boolean | Date};
    notificationType: NotificationType;
}

export type NotificationState = Notification[];
